<template>
    <v-app id="inspire" style="background:#2196F3; background-size: 100% auto; background-image: url('/fondoPersonal.png');">
        <div>
            <v-row v-if="!dMessage.show" justify="center">
                <v-form ref="refMain" v-model="dValid" lazy-validation>
                    <v-card class="portrait">
                        <v-card-title>
                            <v-img
                                src="@/assets/images/bannerTestClimaLaboral.png"
                                width="500px"
                            ></v-img>
                        </v-card-title>
                        <v-card-title>
                            La encuesta es a su Jefe Inmediato.
                        </v-card-title>
                        <v-card-subtitle>
                            La presente encuesta es confidencial, anónima y solo será procesada por la oficina de psicología del área de bienestar de la Corporación Khipu SAC.<br/>
                            Esta prueba tiene la finalidad de conocer la percepción de los trabajadores sobre aspectos como la comunicación interna, el trabajo en sí mismo, las tareas que desempeña, la calidad del espacio de trabajo y otros; sus respuestas nos darán información relevante para modificar conductas, adquirir mejores conocimientos de liderazgo y medir nuestra convivencia laboral.
                        </v-card-subtitle>
                        <v-card v-for="item in dQuestion" :key="item.nro" class="mx-3 my-2 mr-1">
                            <v-card-text class="py-5" style="background:#E3F2FD">
                                <span class="doc-card-title py-2"> {{item.nro}} </span>
                                <span class="text-h2 font-weight-black ml-3">
                                    {{item.ask}}
                                </span>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions class="py-0">
                                <v-radio-group v-model="item.IdAlternativa" row :rules="[v => !!v || 'El campo es requerido']">
                                    <v-radio label="Totalmente de acuerdo" value="169" color="success"></v-radio>
                                    <v-radio label="De acuerdo" value="170" color="success"></v-radio>
                                    <v-radio label="Indeciso" value="302" color="success"></v-radio>
                                    <v-radio label="En desacuerdo" value="171" color="success"></v-radio>
                                    <v-radio label="Totalmente en desacuerdo" value="172" color="success"></v-radio>
                                </v-radio-group>
                            </v-card-actions>
                        </v-card>
                        <v-divider></v-divider>
                        <v-card-actions class="py-0">
                            <v-btn
                                :loading="dLoading"
                                :disabled="dLoading"
                                color="primary"
                                class="ma-2 white--text"
                                @click.prevent="fuSubmit"
                            >
                                Enviar Respuestas
                                <v-icon right dark>
                                    send
                                </v-icon>
                            </v-btn>
                        </v-card-actions>
                        <p style="color:white">{{ $route.params.pIdPersonal }}</p>
                        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, le falta responder.
                            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
                        </v-snackbar>
                    </v-card>
                </v-form>
            </v-row>
            <v-row v-else justify="center">
                <div class="bg-blue text-white text-center q-pa-md flex flex-center">
                    <div>
                        <div>
                            <v-icon size="260" dark>{{dMessage.icon}}</v-icon>
                        </div>
                        <p class="text-h2" style="font-size: 5vh; opacity:.8; color:white" v-html="dMessage.text">
                        </p>
                    </div>
                </div>
            </v-row>
        </div>
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'TestClimaLaboral',
    mounted(){
        if (!this.$route.params.pIdPersonal){
            this.dMessage = {
                show: true,
                text:"Hubo un error<br/>Pruebe actualizar la pagina o llamar al nro. 984130103",
                icon: "cancel"
            }
        } else {
            this.fuLoad();
        }
    },
    data: () => ({
        dLoading : false,
        dMessage: {
            show: false,
            text: "",
            icon: ""
        },
        dPersonal: "",
        dQuestion : [
            {nro : '1', IdPregunta : '416', ask : 'La distribución física del ambiente de trabajo facilita la realización de mis labores', IdAlternativa : ''},
            {nro : '2', IdPregunta : '417', ask : 'Mi sueldo es muy bajo en relación a la labor que realizo', IdAlternativa : ''},
            {nro : '3', IdPregunta : '418', ask : 'El ambiente creado por mis compañeros de trabajo es el ideal para desempeñar mis funciones', IdAlternativa : ''},
            {nro : '4', IdPregunta : '419', ask : 'Siento que el trabajo que hago es justo para mi manera de ser', IdAlternativa : ''},
            {nro : '5', IdPregunta : '420', ask : 'La tarea que realizo es tan valiosa como cualquier otra', IdAlternativa : ''},
            {nro : '6', IdPregunta : '421', ask : 'Mi(s) jefe(s) es(son) comprensivo(s)', IdAlternativa : ''},
            {nro : '7', IdPregunta : '422', ask : 'Me siento mal con lo que gano', IdAlternativa : ''},
            {nro : '8', IdPregunta : '423', ask : 'Siento que recibo de parte de la empresa mal trato', IdAlternativa : ''},
            {nro : '9', IdPregunta : '424', ask : 'Me agrada trabajar con mis compañeros', IdAlternativa : ''},
            {nro : '10', IdPregunta : '425', ask : 'Mi trabajo me permite desarrollarme personalmente', IdAlternativa : ''},
            {nro : '11', IdPregunta : '426', ask : 'Me siento realmente útil con la labor que realizo', IdAlternativa : ''},
            {nro : '12', IdPregunta : '427', ask : 'Es grata la disposición de mis jefes cuando les pido alguna consulta sobre mi trabajo', IdAlternativa : ''},
            {nro : '13', IdPregunta : '428', ask : 'El ambiente donde trabajo es confortable', IdAlternativa : ''},
            {nro : '14', IdPregunta : '429', ask : 'Siento que el sueldo que tengo es bastante aceptable', IdAlternativa : ''},
            {nro : '15', IdPregunta : '430', ask : 'La sensación que tengo en mi trabajo es que me están explotando', IdAlternativa : ''},
            {nro : '16', IdPregunta : '431', ask : 'Prefiero tener distancias con las personas con las que trabajo', IdAlternativa : ''},
            {nro : '17', IdPregunta : '432', ask : 'Me disgusta mi horario', IdAlternativa : ''},
            {nro : '18', IdPregunta : '433', ask : 'Disfruto de cada labor que realizo en mi trabajo', IdAlternativa : ''},
            {nro : '19', IdPregunta : '434', ask : 'Las tareas que realizo las percibo como algo sin importancia', IdAlternativa : ''},
            {nro : '20', IdPregunta : '435', ask : 'Llevarse bien con el jefe beneficia en la calidad de trabajo', IdAlternativa : ''},
            {nro : '21', IdPregunta : '436', ask : 'La comodidad que me ofrece el ambiente de mi trabajo es inigualable', IdAlternativa : ''},
            {nro : '22', IdPregunta : '437', ask : 'Felizmente mi trabajo me permite cubrir mis expectativas económicas', IdAlternativa : ''},
            {nro : '23', IdPregunta : '438', ask : 'El horario me resulta incómodo', IdAlternativa : ''},
            {nro : '24', IdPregunta : '439', ask : 'La solidaridad es una virtud característica en nuestro grupo de trabajo', IdAlternativa : ''},
            {nro : '25', IdPregunta : '440', ask : 'Me siento muy feliz por los resultados que logro en mi trabajo', IdAlternativa : ''},
            {nro : '26', IdPregunta : '441', ask : 'Mi trabajo me aburre', IdAlternativa : ''},
            {nro : '27', IdPregunta : '442', ask : 'La relación que tengo con mis superiores es cordial', IdAlternativa : ''},
            {nro : '28', IdPregunta : '443', ask : 'En el ambiente físico donde me ubico, trabajo cómodamente', IdAlternativa : ''},
            {nro : '29', IdPregunta : '444', ask : 'Mi trabajo me hace sentir realizado(a)', IdAlternativa : ''},
            {nro : '30', IdPregunta : '445', ask : 'Me gusta el trabajo que realizo', IdAlternativa : ''},
            {nro : '31', IdPregunta : '446', ask : 'No me siento a gusto con mi jefe', IdAlternativa : ''},
            {nro : '32', IdPregunta : '447', ask : 'Existen las comodidades para un buen desempeño de las labores diarias', IdAlternativa : ''},
            {nro : '33', IdPregunta : '448', ask : 'No te reconocen el esfuerzo si trabajas más de las horas reglamentarias', IdAlternativa : ''},
            {nro : '34', IdPregunta : '449', ask : 'Haciendo mi trabajo me siento bien conmigo mismo(a)', IdAlternativa : ''},
            {nro : '35', IdPregunta : '450', ask : 'Me siento complacido con la actividad que realizo', IdAlternativa : ''},
            {nro : '36', IdPregunta : '451', ask : 'Mi jefe valora el esfuerzo que hago en mi trabajo', IdAlternativa : ''},
        ],
        dSnackbar: false,
        dValid: false,
    }),

    methods: {
        async fuLoad() {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query cceencuestapersonalByEstadoByDenominacionByIdPersonalByIDCentroProd($IdPersonal: Int!, $IDCentroProd: Int!){
                        cceencuestapersonalByEstadoByDenominacionByIdPersonalByIDCentroProd(Estado:"EVALUADO", Denominacion:"TEST PSICOLOGICO PERSONAL 2023", IdPersonal:$IdPersonal, IDCentroProd:$IDCentroProd){
                            IdEncuesta
                            Fecha
                            Estado
                            Denominacion
                        }
                    }`,
                    variables: {
                        IdPersonal: this.$route.params.pIdPersonal,
                        IDCentroProd:this.$route.params.pIDCentroProd
                    }
                })
                if(!response.data.cceencuestapersonalByEstadoByDenominacionByIdPersonalByIDCentroProd){
                    this.dMessage = {
                        show: true,
                        text:"Hubo un error<br/>Pruebe actualizar la pagina o llamar al nro. 984130103",
                        icon: "cancel"
                    }
                } else {
                    if(response.data.cceencuestapersonalByEstadoByDenominacionByIdPersonalByIDCentroProd.length){
                        this.dMessage = {
                            show: true,
                            text:"Ya envió la encuesta. <br/> Cualquier observación llamar al nro. 984130103.",
                            icon: "thumb_up"
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuSubmit(){
            this.$refs.refMain.validate()
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {
                this.fuCreate();
            }
        },
        async fuCreate(){
            let varray = this.dQuestion.map(item => {
                return {
                    IdPregunta: item.IdPregunta,
                    IdAlternativa: item.IdAlternativa
                }
            });
            varray=JSON.stringify(varray);
            this.dLoading = true;
            let vIdPersonal = this.$route.params.pIdPersonal;
            let vDenominacion = "TEST PSICOLOGICO PERSONAL 2023";
            
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation cceencuestapersonalCreateArray($IdPersonal: Int!, $IDCentroProd: Int!, $Denominacion: String!, $array: String!){
                        cceencuestapersonalCreateArray(IdPersonal:$IdPersonal, IDCentroProd:$IDCentroProd, Denominacion: $Denominacion, array: $array){
                            success
                            message
                        }
                    }`,
                    variables: {
                        IdPersonal: vIdPersonal,
                        IDCentroProd: this.$route.params.pIDCentroProd,
                        Denominacion: vDenominacion,
                        array: varray,                        
                    }
                });
                if(response.data){
                    console.log(response.data);
                    this.dMessage = {
                        show: true,
                        text:"La encuesta se envió correctamente.",
                        icon: "check_circle"
                    }
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                this.fuLogTraceCreate('TestClimaLaboral', 'INF01', 'ERROR', 'Error al crear',vDenominacion, vIdPersonal,0, vIdPersonal);
            } finally {
                this.dLoading = false;
            }
        },
        async fuLogTraceCreate(vmodulo, vcodigo, vtipo, vmensaje, vdetalle, vid_cliente, vestado, vusuario){
            const response = await this.$apollo.mutate({
                mutation: gql`mutation logtraceCreate($modulo:String!, $codigo:String, $tipo:String!, $mensaje:String!, $detalle: String, $id_cliente: String, $estado: Int, $usuario: Int){
                    logtraceCreate(input:{
                        sistema:"academico web",
                        modulo:$modulo,
                        codigo:$codigo,
                        tipo:$tipo,
                        mensaje:$mensaje,
                        detalle:$detalle,
                        id_cliente:$id_cliente,
                        estado:$estado,
                        usuario:$usuario
                    }){
                        id
                    }
                }`,
                variables: {
                    modulo: vmodulo,
                    codigo: vcodigo,
                    tipo: vtipo,
                    mensaje: vmensaje,
                    detalle: vdetalle,
                    id_cliente: vid_cliente,
                    estado: vestado,
                    usuario: vusuario
                }
            });
        },
    },
}
</script>

<style scoped>
    .portrait.v-card {
        margin: 0 auto;
        max-width: 880px;
        width: 100%;
    }
    .doc-card-title {
        margin-left: -24px;
        padding: 2px 10px 2px 24px;
        background: #2249A7;
        color: #ffffff;
        position: relative;
        border-radius: 3px 5px 5px 0;
        width: 100;
    }
</style>
